const productList = document.querySelector(".boost-sd__filter-product-list.boost-sd__filter-product-list--ready");

if (!productList) {
    console.error("Product list not found!");
} else {
    const config = { childList: true };

    const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.target === productList) {
                console.log("PRODUCT LIST RERENDERS");
              var productCount = $('.boost-sd__product-count').html();
              console.log(productCount,'countttttt');
              $('.boost-sd__refine-by-vertical-refine-by-title').append('<div class="collection-product-count">'+productCount+'</div>');
              // $('.boost-sd__product-count').hide();
              
            }
        }
    };

    const observer = new MutationObserver(callback);

    try {
        observer.observe(productList, config);
    } catch (error) {
        console.error("Observer failed");
    }
}